import { FilterOption, Pagination } from './types';
import { TagItem } from '../../types';
import { EventDetailTagGroup, EventDetailTagItem } from '../../../../../types/query/event/detail';

export const convertToTableData = (data?: EventDetailTagItem[]): TagItem[] => {
  if (!data) return [];
  return data.map((item) => ({
    id: item.tag.id,
    name: item.tag.name,
    status: item.tag.status,
    tagGroupList: item.tagGroupList.map((item: EventDetailTagGroup) => item.name),
    imageUrl: item.tagAttachmentList[0]?.url,
    eventId: item.id,
    createDate: item.tag.createDate,
  }));
};

export const applyFilterOption = (data: TagItem[], filterOption: FilterOption) => {
  return data.filter((item) => {
    // 각 조건을 검사하고 필터링 조건이 없거나 일치하면 true를 반환합니다.
    return (
      (!filterOption.name || item.name.match(filterOption.name)) &&
      (filterOption.id === null || item.id === Number(filterOption.id))
    );
  });
};

export const applyPagination = (data: TagItem[], pagination: Pagination) => {
  return data.slice(pagination.pageNum * pagination.pageSize, (pagination.pageNum + 1) * pagination.pageSize);
};
